var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo, useRef } from 'react';
export const useFileAsyncValidation = ({ baseValidate, onInspectFileStatus, timeout = 500, }) => {
    const validateDebounceRef = useRef({});
    const fileAsyncValidate = useMemo(() => baseValidate((id, allValues, meta) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (id) {
            const currentData = validateDebounceRef.current[id] || {
                inProgress: false,
                result: null,
                value: null,
            };
            if (currentData === null || currentData === void 0 ? void 0 : currentData.inProgress) {
                return '';
            }
            if (id !== currentData.value) {
                yield new Promise((resolve) => {
                    window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                        validateDebounceRef.current[id] = Object.assign(Object.assign({}, validateDebounceRef.current[id]), { inProgress: true, value: id });
                        try {
                            validateDebounceRef.current[id].result =
                                yield onInspectFileStatus(id, meta === null || meta === void 0 ? void 0 : meta.extra.fieldUnmountRef);
                        }
                        finally {
                            validateDebounceRef.current[id].inProgress = false;
                        }
                        resolve();
                    }), timeout);
                });
            }
            const result = (_a = validateDebounceRef.current[id]) === null || _a === void 0 ? void 0 : _a.result;
            return !(result === null || result === void 0 ? void 0 : result.result) && (result === null || result === void 0 ? void 0 : result.message) ? result.message : '';
        }
        return '';
    })), [baseValidate, onInspectFileStatus, timeout]);
    return {
        fileAsyncValidate,
    };
};
